<div class="relative w-full h-full">
  
  <div class="overflow-y-auto w-full h-[calc(100%-3rem)]">
    <div>
      <div class="block my-5">
        <div class="flex items-center">
          <span class="block subtitle-1 text-black">
            {{ 'iqboost.privacySecurityCenter.aiInUse' | translate }}
          </span>
          @if (!isFFGlobalModelsEnabled) {
            <span
              class="text-body-2 ml-2 inline-flex items-center gap-1 p-2 bg-neutral-5 rounded-sm h-6 leading-3"
            >
              <span
                class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
              ></span>
              <span
                [innerHTML]="'permissions.organizationPermissionMessage' | translate"
              ></span>
            </span>
          }
          @else if (!isAdmin() && !isGlobalModelsEnabledByAdmin()) {
            <span
              class="text-body-2 ml-2 inline-flex items-center gap-1 p-2 bg-neutral-5 rounded-sm h-6 leading-3"
            >
              <span
                class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
              ></span>
              <span
                [innerHTML]="'permissions.adminPermissionMessage' | translate"
              ></span>
            </span>
          }
        </div>

        <span class="block text-body-2 text-black">
          {{ 'iqboost.privacySecurityCenter.aiInUseDescription' | translate }}
        </span>

        <div class="flex mt-3">
          <div class="block">
            <div class="flex items-center">
              <input type="radio" 
                    kendoRadioButton
                    [disabled]="isGlobalModelsLocked()"
                    [value]="false"
                    [(ngModel)]="dataProcessingFeatures().useGlobalServers"
                    id="canadianServers"
                    name="serverLocation" />
              <span class="svg-icons icon-flag-canada icon-16 pt-0.5 pl-2"></span>
              <label for="canadianServers" class="k-label text-body-2 text-black pl-2">
                {{ 'iqboost.privacySecurityCenter.canadianServers' | translate }}
              </label>
              <span class="text-body-2 text-black h-6.5 leading-3 ml-6 p-2 bg-bush-green-10">
                {{ 'iqboost.privacySecurityCenter.recommended' | translate }}
              </span>
            </div>

            <div class="flex items-center mt-2">
              <input type="radio"
                    kendoRadioButton 
                    [disabled]="isGlobalModelsLocked()"
                    [value]="true"
                    [(ngModel)]="dataProcessingFeatures().useGlobalServers"
                    id="globalServers"
                    name="serverLocation" />
              <span class="fa-icons icon-earth-americas icon-16 pt-0.5 pl-2"></span>
              <label for="globalServers" class="k-label text-body-2 text-black pl-2">
                {{ 'iqboost.privacySecurityCenter.globalServers' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="block mb-5">
        <div class="flex items-center">
          <span class="block subtitle-1 text-black">
            {{ 'iqboost.privacySecurityCenter.dataInUse' | translate }}
          </span>
          @if (!isFFOnlineResourcesEnabled) {
            <span
              class="text-body-2 ml-2 inline-flex items-center gap-1 p-2 bg-neutral-5 rounded-sm h-6 leading-3"
            >
              <span
                class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
              ></span>
              <span
                [innerHTML]="'permissions.organizationPermissionMessage' | translate"
              ></span>
            </span>
          }
          @else if (!isAdmin() && !isOnlineResourcesEnabledByAdmin()) {
            <span
              class="text-body-2 ml-2 inline-flex items-center gap-1 p-2 bg-neutral-5 rounded-sm h-6 leading-3"
            >
              <span
                class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
              ></span>
              <span
                [innerHTML]="'permissions.adminPermissionMessage' | translate"
              ></span>
            </span>
          }
        </div>

        <span class="block text-body-2 text-black">
          {{ 'iqboost.privacySecurityCenter.maximizerSource' | translate }}
        </span>

        <div class="flex mt-3">
          <div class="block">
            <div class="flex items-center">
              <input type="radio" 
                    kendoRadioButton
                    [disabled]="isOnlineResourcesLocked()"
                    [value]="false"
                    [(ngModel)]="dataProcessingFeatures().useWebData"
                    id="maximizerData"
                    name="dataSource" />
              <img class="w-4 pt-0.5 ml-2 bg-black rounded"
                [src]="cdn + '/assets/images/logo.svg'"
                alt="maximizer"
              />
              <label for="maximizerData" class="k-label text-body-2 text-black pl-2">
                {{ 'iqboost.privacySecurityCenter.maximizerData' | translate }}
              </label>
            </div>

            <div class="flex items-center mt-2">
              <input type="radio"
                    kendoRadioButton 
                    [disabled]="isOnlineResourcesLocked()"
                    [value]="true"
                    [(ngModel)]="dataProcessingFeatures().useWebData"
                    id="webData"
                    name="dataSource" />
              <span class="fa-icons icon-globe-pointer icon-16 pt-0.5 pl-2"></span>
              <label for="webData" class="k-label text-body-2 text-black pl-2">
                {{ 'iqboost.privacySecurityCenter.webData' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block mb-5">
      <span class="block subtitle-1 text-black">
        {{ 'iqboost.privacySecurityCenter.dataScope.dateFiltering.title' | translate }}
      </span>
      <span class="block text-black text-body-2 pb-2">
        {{ 'iqboost.privacySecurityCenter.dataScope.dateFiltering.description' | translate }}
      </span>

      <div class="block">
        <div class="flex items-center text-body-1 text-black py-0.5">
          <kendo-dropdownlist
            #dueDateSelector
            valueField="id"
            textField="name"
            [data]="dueDates()"
            [(ngModel)]="selectedDueDate"
            class="h-8.5 mt-0.5"
            style="min-width: 280px; max-width: 350px"
            [listHeight]="500"
          >
            <ng-template
              kendoDropDownListItemTemplate
              kendoDropDownListValueTemplate
              let-item
            >
              {{
                item?.translationID | translate
              }}
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </div>
    </div>

    <div>
      <div class="block">
        <span class="block subtitle-1 text-black">
          {{ 'iqboost.privacySecurityCenter.selectData' | translate }}
        </span>

        <span class="block text-black text-body-2 pb-2">
          {{ 'iqboost.privacySecurityCenter.selectDataDescription' | translate }}
        </span>
      </div>

      <div class="block ml-2">
        <div class="block text-body-1 text-black py-0.5">
          <input id="householdDetails"
            type="checkbox" 
            [(ngModel)]="dataScope().householdDetails"
            kendoCheckBox
          />
          <kendo-label [for]="'householdDetails'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.householdDetails' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="accountDetails"
            type="checkbox"
            [(ngModel)]="dataScope().accountDetails"
            kendoCheckBox
          />
          <kendo-label [for]="'accountDetails'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.accountDetails' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="notes"
            type="checkbox"
            [(ngModel)]="dataScope().notes"
            kendoCheckBox
          />
          <kendo-label [for]="'notes'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.notes' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="emails"
            type="checkbox"
            [(ngModel)]="dataScope().emails"
            kendoCheckBox
          />
          <kendo-label [for]="'emails'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.emails' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="documents"
            type="checkbox"
            [(ngModel)]="dataScope().documents"
            kendoCheckBox
          />
          <kendo-label [for]="'documents'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.documents' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="calls"
            type="checkbox"
            [(ngModel)]="dataScope().calls"
            kendoCheckBox
          />
          <kendo-label [for]="'calls'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.calls' | translate }}
          </kendo-label>
        </div>
        
        <div class="block text-body-1 text-black py-0.5">
          <input id="allInteractions"
            type="checkbox"
            [(ngModel)]="dataScope().allInteractions"
            kendoCheckBox
          />
          <kendo-label [for]="'allInteractions'" class="k-checkbox-label">
            {{ 'iqboost.privacySecurityCenter.dataScope.' + textVersion() + '.allInteractions' | translate }}
          </kendo-label>
        </div>                
      </div>
    </div>
  </div>
  
  <div class="flex justify-end items-center px-4 absolute bottom-0 right-0 bg-white w-full shadow-md">
    <button
      kendoButton
      themeColor="primary"
      [disabled]="store.loading()"
      (click)="closePrivacySecurityCenter()"
      class="h-[34px] rounded p-2"
    >
      <div class="flex items-center">
        {{ 'iqboost.privacySecurityCenter.saveSettings' | translate }}
      </div>
    </button>
  </div>
</div> 